'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    font-weight: inherit;\n  '], ['\n    font-weight: inherit;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    font-weight: 300;\n  '], ['\n    font-weight: 300;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    font-weight: 400;\n  '], ['\n    font-weight: 400;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    font-weight: 500;\n  '], ['\n    font-weight: 500;\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    font-weight: 700;\n  '], ['\n    font-weight: 700;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n  color: ', ';\n  ', ';\n'], ['\n  color: ', ';\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../../libs/colors');

var colors = _interopRequireWildcard(_colors);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors


var fontWeight = {
  inherit: (0, _styledComponents.css)(_templateObject),
  thin: (0, _styledComponents.css)(_templateObject2),
  normal: (0, _styledComponents.css)(_templateObject3),
  medium: (0, _styledComponents.css)(_templateObject4),
  bold: (0, _styledComponents.css)(_templateObject5)
};

var TextColor = _styledComponents2.default.span(_templateObject6, function (_ref) {
  var theme = _ref.theme;
  return colors[theme];
}, function (_ref2) {
  var weight = _ref2.weight;
  return fontWeight[weight];
});

TextColor.propTypes = {
  theme: _propTypes2.default.oneOf(Object.keys(colors)),
  weight: _propTypes2.default.oneOf(['thin', 'normal', 'medium', 'bold', 'inherit'])
};
TextColor.defaultProps = {
  theme: 'black',
  weight: 'inherit'
};
exports.default = TextColor;